export const UPLOAD = {
  container: "upload-container",
  resumeInput: "resume-input",
  coverInput: "cover-letter-input",
  jobInput: "job-description-input",
  numQuestions: "num-questions-input",
  startBtn: "start-interview-button",
};

export const INTERVIEW = {
  container: "interview-container",
  questionText: "question-text",
  playQuestion: "play-question-button",
  recordBtn: "record-button",
  stopBtn: "stop-button",
  playbackBtn: "playback-button",
  submitBtn: "submit-answer-button",
  reRecordBtn: "re-record-button",
  nextBtn: "next-question-button",
  finishBtn: "finish-interview-button",
  progressLabel: "progress-label",
};

export const REPORT = {
  container: "report-container",
  overallScore: "overall-score",
  questionCard: (i) => `question-report-${i}`,
  restartBtn: "restart-button",
  betaFeedbackBtn: "beta-feedback-button",
  downloadReportBtn: "download-report-pdf",
};

export const BETA_FB = {
  container: "beta-feedback-container",
  backBtn: "beta-feedback-back-button",
  submitBtn: "beta-feedback-submit-button",
  stickyBar: "beta-feedback-sticky-bar",
  progressLabel: "beta-feedback-progress-label",
};
